import MenuMobileView from './menu-mobil-view'

export default MenuMobileView
